import { RefObject,useEffect, useRef, useState } from 'react';

type Size = {
  width: number;
  height: number;
};

type UseResizeObserverProps = {
  ref: RefObject<HTMLElement>;
};

export default function useResizeObserver({ ref }: UseResizeObserverProps): Size {
  const [elementSizes, setElementSizes] = useState<Size>({ width: 0, height: 0 });
  const heightRef = useRef(0);

  useEffect(() => {
    if (!ref.current) return;

    const observer = new ResizeObserver(([entry]) => {
      const entryHeight = entry.target.clientHeight;
      const entryWidth = entry.target.clientWidth;

      if (entryHeight !== heightRef.current) {
        heightRef.current = entryHeight;
        setElementSizes({ height: entryHeight, width: entryWidth });
      }
    });

    observer.observe(ref.current, { box: 'border-box' });

    return () => {
      observer.disconnect();
    };
  }, [ref]);

  return elementSizes;
}
